import request from '../../api/request';
import { StudentsRemovalRequestViewResponse } from './types';

const STUDENTS_REMOVAL_REQUEST = {
  VIEW: (studentRemovalRequestId: number) =>
    `maintainers-portal/student-management/students-removal-request-view/${studentRemovalRequestId}`,
};

export async function getStudentRemovalRequestView(
  studentRemovalRequestId: number,
) {
  return request<StudentsRemovalRequestViewResponse>(
    STUDENTS_REMOVAL_REQUEST.VIEW(studentRemovalRequestId),
    {
      method: 'GET',
    },
  );
}
